﻿import defRes from "./dbstrings.json";

let resourceSource = document.documentElement;
const resourceSet = { ...defRes };

function ensureResourceSet() {
	if (!Object.isFrozen(resourceSet)) {
		const resourceText = (resourceSource || document.documentElement).dataset.jsResources;
		if(resourceText) {
			Object.entries(JSON.parse(resourceText)).forEach(([k, v]) => resourceSet[k] = v);
		}
		Object.freeze(resourceSet);
	}
	return resourceSet;
}

function getString(key) {
	ensureResourceSet();
	return resourceSet[key] ?? key;
}

function setResourceSource(element) {
	resourceSource = element || document.documentElement;
}

export { getString, setResourceSource, resourceSet };